
import { Link } from 'react-router-dom';
import { categories } from '../../../mocks/categories';

export default function Categories() {
  return (
    <section className="py-20" style={{ backgroundColor: '#0D1B2A' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4 text-white" style={{ fontFamily: "'Tajawal', sans-serif" }}>
            تسوق حسب الفئة
          </h2>
          <p className="text-lg max-w-2xl mx-auto text-gray-400">
            اختر من بين مجموعة متنوعة من الفئات لتجد ما تبحث عنه بسهولة
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {categories.map((category) => (
            <Link 
              key={category.id}
              to={`/categories?cat=${category.slug}`}
              className="group cursor-pointer"
            >
              <div className="relative overflow-hidden rounded-2xl shadow-md hover:shadow-xl transition-all duration-300" style={{ backgroundColor: '#1B2D3E' }}>
                <div className="aspect-square w-full h-full overflow-hidden">
                  <img 
                    src={category.image}
                    alt={category.name}
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-[#0D1B2A]/90 via-[#0D1B2A]/40 to-transparent flex items-end">
                  <div className="p-6 w-full">
                    <h3 className="text-xl font-bold text-white mb-1" style={{ fontFamily: "'Tajawal', sans-serif" }}>
                      {category.name}
                    </h3>
                    <p className="text-sm" style={{ color: '#D4A84B' }}>{category.count} منتج</p>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
